import { inject, Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomRequisitionPrecedent } from '@models/requisitions';
import { SnackbarService } from '@services/ui/snackbar.service';
import { BaseRequisitionModal } from '../base-requisition-modal';
import { Store } from '@ngxs/store';
import { BusinessRequisitionsState } from '@state/business/requisition/business_requisitions.state';
import { BusinessRequisitionsDispatch } from '@state/business/requisition/business_requisitions.dispatch';

export interface INewCustomRequisitionModalData {
	selectedRequisitionId: string;
}

@Injectable()
export abstract class BaseCustomRequisitionModal extends BaseRequisitionModal<CustomRequisitionPrecedent> {
	protected statusState$ = inject(Store).select(
		BusinessRequisitionsState.getCreateStatus,
	);
	abstract successMessage: string;
	abstract errorMessage: string;

	constructor(
		public data: INewCustomRequisitionModalData,
		protected dialogRef: MatDialogRef<unknown, string>,
		protected businessRequisitionsDispatch: BusinessRequisitionsDispatch,
		protected snackbarService: SnackbarService,
	) {
		super(dialogRef, snackbarService);
	}
}
